// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Belt_Array from "../../../../../../../../../node_modules/rescript/lib/es6/belt_Array.js";

function AllocationCampaignValidation(Props) {
  var validationData = Props.validationData;
  return React.createElement("div", {
              className: "section"
            }, Belt_Array.map(validationData.validations, (function (validation) {
                    var segmentNamesStr = validation.segment_names.join(", ");
                    return React.createElement("div", {
                                key: validation.validation_type
                              }, React.createElement("div", {
                                    className: "section-row"
                                  }, React.createElement("p", undefined, "Validation Type"), React.createElement("p", {
                                        className: "validation-type"
                                      }, validation.validation_type)), React.createElement("div", {
                                    className: "section-row"
                                  }, React.createElement("p", undefined, "Segment Names"), React.createElement("p", {
                                        className: "value segment-names"
                                      }, segmentNamesStr)));
                  })));
}

var make = AllocationCampaignValidation;

export {
  make ,
  
}
/* react Not a pure module */
